import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { ScrollButton } from './ui/Button';
export function FinalCTA() {
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const benefits = ['Clientes premium que pagan lo que vales', 'Sistema probado con +150 spas en Estados Unidos', 'Sin contratos — resultados o no pagas'];
  return <section className="py-24 md:py-32 px-4 relative overflow-hidden border-t border-border bg-carbon" data-id="element-89">
      {/* Subtle background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-[800px] h-[400px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-90" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="bg-surface border border-border rounded-3xl p-8 md:p-16 shadow-2xl flex flex-col items-center" data-id="element-92">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gold mb-4 tracking-tight" data-id="element-93">
            ¿Lista Para Dejar de Regalar Tu Talento?
          </h2>

          <p className="text-amber-500 font-medium mb-10 text-lg md:text-xl" data-id="element-94">
            Solo aceptamos 5 spas nuevos por mes para garantizar resultados.
            Verifica disponibilidad en tu zona.
          </p>

          <div className="w-full max-w-md mx-auto text-left space-y-4 mb-10" data-id="element-95">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3" data-id="element-96">
                <CheckCircle2 className="w-6 h-6 text-emerald shrink-0 mt-0.5" data-id="element-97" />
                <span className="text-white text-lg" data-id="element-98">{benefit}</span>
              </div>)}
          </div>

          <ScrollButton onClick={scrollToContact} className="w-full md:w-auto text-sm md:text-base mb-6" data-id="element-99">
            QUIERO CLIENTES QUE PAGUEN MIS PRECIOS REALES
          </ScrollButton>

          <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-gold transition-colors flex items-center gap-2 text-sm font-medium" data-id="element-100">
            O agenda directamente en nuestro calendario{' '}
            <ArrowRight className="w-4 h-4" data-id="element-101" />
          </a>
        </motion.div>
      </div>
    </section>;
}